import TabLabel from './TabLabel';

export default function TabLabelTradeHistory() {
  return <TabLabel>Trade History</TabLabel>;
}
